module.exports = __webpack_public_path__ + "static/icon_duefocus_clickUp-5329ad61950a73306ca494ab2e124d7a.svg";